import { ADD_SERVICE_PROVIDERS_LIST, ACTIVE_SERVICE_PROVIDER } from "../actions";

const addServiceProvidersList = (state, serviceProviders) => {
    return { ...state, serviceProviders: [...serviceProviders] };
};

const activeServiceProvider = (state, serviceProvider) => {
    return { ...state, serviceProvider };
};

export const reducer = (state, action) => {
    switch (action.type) {
        case ADD_SERVICE_PROVIDERS_LIST:
            return addServiceProvidersList(state, action.serviceProviders);
        case ACTIVE_SERVICE_PROVIDER:
            return activeServiceProvider(state, action.serviceProvider);
        default:
            return state;
    }
};